/**
 * Canonical `place_type.id` and `zone_type.id` values used by the API and floor plans.
 * Align with {@link BookingType} comments in `./booking-inputs`.
 */
export const WORKPLACE_PLACE_TYPE_ID = 1;
export const PARKING_PLACE_TYPE_ID = 2;
export const ELECTRIC_CHARGING_PLACE_TYPE_ID = 4;
/** Fleet / vehicle booking — see `BookingType.VEHICLE` */
export const VEHICLE_PLACE_TYPE_ID = 5;

/** Meeting / conference zones — see `BookingType.CONFERENCEZONE` */
export const CONFERENCE_ZONE_TYPE_ID = 3;
